import styled from 'styled-components';
import { Dropdown } from 'components/Dropdown';

export const StyledDropdown = styled(Dropdown)`
  width: 253px;
  input {
    text-overflow: ellipsis;
  }
`;
